export const LOAN_API = {
    LOAN_CREATE: { url: "/loan", method: "POST" },
    LOAN_LIST: { url: "/loan", method: "GET" },
};
export const LOAN_INITIAL_STATE = {
    employee_id: "",
    loan_amount: "",
    gross_salary: "",
    deduction_type: "fixed",
    tenure: "",
    monthly_deduction: "",
    loan_issue_date: ""
}